import React from 'react';
import PremiacoesPage from './PremiacoesPage';
import cidadeBH from '../data/cidades/belo-horizonte.json';
import premiacoesBH from '../data/premiacoes/belo-horizonte.json';

const PremiacoesBHPage = () => (
  <PremiacoesPage cidade={cidadeBH} premiacao={premiacoesBH} />
);

export default PremiacoesBHPage;
